export const skuCard_15 = {    
    promoLineStyle: {
        color: '#000000',
        fontSize: '16px',
        'font-weight' : '700',
        lineHeight: '20px',
    }
}